import posthog from "posthog-js";
import AppConfig from "../config/app";

/**
 * Reports a handled exception to PostHog error tracking. Kept apart from
 * AnalyticsAdaptors so entities can report without loading its import chain.
 * @param {Error} error
 * @param {Object} [properties]
 */
export const captureExceptionPostHog = (error, properties) => {
  if (AppConfig.posthog) {
    posthog.captureException(error, properties);
  }
};
